import type { TextareaHTMLAttributes } from 'react';
import './Textarea.css';

export type TextareaProps = TextareaHTMLAttributes<HTMLTextAreaElement>;

export function Textarea({ className, ...rest }: TextareaProps) {
  const classes = ['dma-textarea', className].filter(Boolean).join(' ');
  return <textarea className={classes} {...rest} />;
}
